import React from "react";
import "./Game_History_card.css";
import { formatAmount } from "../../../utils/common";

function Game_History_card({
  game,
  resultClass,
  time,
  type,
  period,
  select,
  totalBet,
  // ballImage,
  actualAmount,
  winnings,
  fee,
  profitClass,
  profit,
  loss,
  result,
  data,
  periodResult,
}) {


  const number = periodResult?.number;
  const size = periodResult?.size?.toLowerCase();
  const color = periodResult?.color?.toLowerCase();

  let ballImage = `/assets/images/bet_Select_section/coint_${number}.png`;

  // Size tag
  const sizeTag = size
    ? { text: size.charAt(0).toUpperCase() + size.slice(1), class: size }
    : null;

  const colorTagMap = {
    "green": { text: "Green", class: "green" },
    "red": { text: "Red", class: "red" },
    "violet": { text: "Violet", class: "violet" },
    "green,violet": { text: "Green Violet", class: "green_purple" },
    "violet, red": { text: "Violet Red", class: "violet_red" },
  };



  const colorTag = colorTagMap[color] ?? { text: color, class: color?.replace(",", "_") };

  const tags = [colorTag, sizeTag].filter(Boolean);

  return (
    <section className="Game_History_card">
      <div className="history_card">

        {/* Header */}
        <div className="card_header_holder">
          <div className="history_header">
            <div className="game_title">{game}</div>
            <div className={`game_result ${resultClass}`}>
              {result}
            </div>
          </div>

          <div className="history_time">{time}</div>
        </div>

        {/* Details */}
        <div className="history_details">

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Type</span>
            <span className="value">{type}</span>
          </div>

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Period</span>
            <span className="value">{period}</span>
          </div>

          {/* <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Order number</span>
            <span className="value">{order}</span>
          </div> */}

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Select</span>
            <span className="value">{select}</span>
          </div>

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Total Bet</span>
            <span className="value">{totalBet}</span>
          </div>

        </div>

        <div className="divider"></div>

        {/* Lottery Result */}
        <div className="history_details">

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Lottery Results</span>
          </div>

          <div className="detail_row">
            <span className="timeline_point"></span>

            <div className="lottery_result">

              <div className="boll_img_holder">
                <div className="number_circle">
                  <img
                    src={ballImage}
                    className="num_img"
                    alt="ball"
                  />
                </div>
              </div>

              <div className="tags">
                {tags?.map((tag, index) => (
                  <span key={index} className={`tag ${tag.class}`}>
                    {tag.text}
                  </span>
                ))}
              </div>

            </div>

          </div>

        </div>

        {/* Amount Grid */}
        <div className="amount_grid">

          <div className="amount_box">
            <div className="amount">{actualAmount}</div>
            <div className="amount_label">Actual Amount</div>
          </div>

          <div className="amount_box">
            <div className="amount">{winnings}</div>
            <div className="amount_label">Winnings</div>
          </div>

          <div className="amount_box">
            <div className="amount">{fee}</div>
            <div className="amount_label">Handling Fee</div>
          </div>

          <div className="amount_box">
            <div className={`amount ${profitClass}`}>
              {formatAmount(Math.max(profit, loss))}            </div>
            <div className="amount_label">Profit/Loss</div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Game_History_card;